import React, { useState, useEffect, Fragment, useRef } from "react";

import { observer } from "mobx-react-lite";
import { useSnackbar } from "notistack";
import { useStores } from "../../../core/stores/index";
import "./ClaimDetails.css";
import CustomAutoComplete from "components/common/CustomAutoComplete";
import { useNavigate, useParams } from "react-router-dom";
import { ClaimStore } from "core/stores/ClaimStore";
import { IInvoice } from "common/interfaces/IInvoice";
import "react-data-grid/lib/styles.css";
import ReactDataGrid, { Column, textEditor } from "react-data-grid";
import { Spinner } from "components/common/Spinner";
import { DateHelper } from "common/helpers/DateHelper";
import { IUser } from "common/interfaces/IUser";
import { ICreateClaimRequest } from "common/interfaces/apiRequest/ICreateClaimRequest";
import { ClaimType } from "common/enums/ClaimType";
import { IClaim } from "common/interfaces/IClaim";
import { ClaimStatus } from "common/enums/ClaimStatus";
import { IInvoiceLineItemsSearchRequest } from "common/interfaces/apiRequest/IInvoiceLineItemsSearchRequest";
import { response } from "express";
import { IClaimLineItem } from "common/interfaces/IClaimLineItem";
import { ClaimAction } from "common/enums/ClaimAction";
import { IClaimAudit } from "common/interfaces/IClaimAudit";

import { Table, Header, HeaderRow, Body, Row, HeaderCell, Cell } from "@table-library/react-table-library/table";
import { useTheme } from "@table-library/react-table-library/theme";
import { getTheme } from "@table-library/react-table-library/baseline";
import { CompactTable } from "@table-library/react-table-library/compact";
import { TypeHelper } from "common/helpers/TypeHelper";
import { Decimal } from "decimal.js";
import { error } from "console";
import { ApiHelper } from "common/helpers/ApiHelper";
import { IoMdDownload } from "react-icons/io";
import { FaTrashAlt } from "react-icons/fa";
import { ConfirmationModal } from "components/common/ConfirmationModal";
import { IComment } from "common/interfaces/IComment";
import CustomAutoCompleteMultiple from "components/common/CustomAutoCompleteMultiple";
import { IoIosTimer } from "react-icons/io";
import { FaArrowAltCircleDown } from "react-icons/fa";
import { UiHelper } from "../../../common/helpers/UiHelper";

interface CreateClaimProp {
    claimType: string;
    invoice: IInvoice;
}

export const ClaimDetails = observer(() => {
    const { claimStore, userStore } = useStores();
    const snackbar = useSnackbar();
    const navigate = useNavigate();

    const { claimId: claimIdFromParam } = useParams() as { claimId: string };

    const [productLineItems, setProductsLineItems] = useState<IClaimLineItem[]>([]);

    const [data, setData] = useState({ nodes: productLineItems });

    const [claimAudit, setClaimAudit] = useState<IClaimAudit[]>([]);

    const [showLoader, setShowLoader] = useState<boolean | undefined>(undefined);

    const [showAttachmentsLoader, setShowAttachmentsLoader] = useState<boolean | undefined>(undefined);

    const [showAuditLoader, setShowAuditLoader] = useState<boolean | undefined>(undefined);

    const [showProductsLoader, setShowProductsLoader] = useState<boolean | undefined>(undefined);

    const [claimId, setClaimId] = useState<number>(Number(claimIdFromParam));

    const [claimRef, setClaimRef] = useState<string>("");

    const [claim, setClaim] = useState<IClaim | undefined>(undefined);

    const invoice = claimStore.selectedInvoice;

    const [claimType, setClaimType] = useState<string>(claimStore.selectedClaimTypeLabel as string);

    const [claimTypeValue, setClaimTypeValue] = useState<number | undefined>(claimStore.selectedClaimTypeValue);

    const [customerAccount, setCustomerAccount] = useState<string>();

    const [claimExitsForInvoice, setClaimExitsForInvoice] = useState<boolean>();

    const [showQuantityHigherThanInvoiced, setShowQuantityHigherThanInvoiced] = useState<boolean>(false);

    const [invoiceDate, setInvoiceDate] = useState<string>();
    const [orderDate, setOrderDate] = useState<string>();

    const [salesOrderNumber, setSalesOrderNumber] = useState<string>();

    const [customerOrderRef, setCustomerOrderRef] = useState<string>();

    const [invoiceNumber, setInvoiceNumber] = useState<string>();

    const [debitNoteNumber, setDebitNoteNumber] = useState<string>("");

    const [creditReason, setCreditReason] = useState<string>();

    const [accountManagerName, setAccountManagerName] = useState<string>();
    const [accountManagerId, setAccountManagerNameId] = useState<number>();

    const [claimCurrency, setClaimCurrency] = useState<string>();

    const [claimStatus, setClaimStatus] = useState<string>();

    const [claimStatusId, setClaimStatusId] = useState<number | undefined>(undefined);

    const [selectedAccountManager, setSelectedAccountManager] = useState<any>(undefined);

    const [isSelectedAccountManagerValid, setSelectedAccountManagerValid] = useState<boolean>(true);

    const [isDetailsActive, setIsDetailsActive] = useState<boolean>();
    const [isProductsActive, setIsProductsActive] = useState<boolean>(false);
    const [isWorkflowActive, setIsWorkflowActive] = useState<boolean>(false);
    const [isAuditTrailActive, setIsAuditTrailActive] = useState<boolean>(false);

    const [isClaimDetailsLoaded, setIsClaimDetailsLoaded] = useState<boolean | undefined>(undefined);

    const [rmaLabel, setRMALabel] = useState<string | undefined>(undefined);

    const [rmaValue, setRMAValue] = useState<string | undefined>(undefined);

    const [creditNoteNumber, setCreditNoteNumber] = useState<string | undefined>(undefined);

    const getRMALabel = (claimType: number) => {
        let labelVal = "";
        switch (claimType) {
            case ClaimType["Price Claim"]:
                labelVal = "Financial Order";
                break;
            case ClaimType["Inventory Claim"]:
            case ClaimType["RMA"]:
            case ClaimType["Uplift Request"]:
                labelVal = "RMA Number";
                break;
        }
        return labelVal;
    };

    const loadComments = () => {
        setShowCommentsLoader(true);
        claimStore.getCommentsByClaimId(claimId).then((resp) => {
            setComments(resp.comments);
            setShowCommentsLoader(false);
        });
    };

    const getClaimDetails = async (): Promise<any> => {
        if (claimId && claimId > 0) {
            claimStore.getClaimById(claimId).then((response) => {
                const claim: IClaim = response.claim;
                setClaim(claim);
                setCustomerAccount(response.claim.customerAccount);
                setInvoiceDate(response.claim.invoiceDate);
                setOrderDate(response.claim.orderDate);
                setSalesOrderNumber(response.claim.salesOrderNumber);
                setCustomerOrderRef(response.claim.customerOrderRef);
                setClaimRef(response.claim.claimRef);
                setInvoiceNumber(response.claim.invoiceNumber);
                setDebitNoteNumber(response.claim.debitNoteRef);
                setCreditReason(response.claim.creditReason);
                setAccountManagerNameId(response.claim.workflowAccountManagerId);
                setAccountManagerName(response.claim.workflowAccountManagerName);
                setClaimStatus(ClaimStatus[Number(response.claim.claimStatus)]);
                setClaimType(ClaimType[Number(response.claim.claimType)]);
                setClaimTypeValue(Number(response.claim.claimType));
                setClaimCurrency(response.claim.currency);
                console.log(response.claimType);
                setClaimStatusId(Number(response.claim.claimStatus));
                setSelectedAccountManager({ key: claim.workflowAccountManagerId, label: claim.workflowAccountManagerName });
                setIsDetailsActive(true);
                setSelectedAccountManagerValid(true);
                setCreditNoteNumber(claim.creditNoteRef ?? "Not yet available");
                setRMAValue(claim.rmaNumber ?? "Not yet available");
                setRMALabel(getRMALabel(Number(response.claim.claimType)));
                CheckCurrentUserRequestor(response.claim.raisedByUserId).then((resp) => {});
                setIsClaimDetailsLoaded(true);

                if (claimId) {
                    loadComments();
                }
            });
        } else {
            if (invoice) {
                setIsDetailsActive(true);
                setCustomerAccount(invoice.customer);
                setInvoiceDate(invoice.invoiceDate);
                setOrderDate(invoice.orderDate);
                setSalesOrderNumber(invoice.salesOrderNumber);
                setCustomerOrderRef(invoice.customerOrderRef);
                setInvoiceNumber(invoice.invoiceNumber);
                setClaimExitsForInvoice(invoice.claimExists);
                setIsClaimDetailsLoaded(true);
                setClaimCurrency(invoice.currencyCode);
                console.log(invoice.currencyCode);
            }
        }
    };

    const [refreshCounter, setRefreshCounter] = useState<number>(0);

    useEffect(() => {
        userStore.getCurrentUser().then((response) => {
            userStore.getAllUsers().then((response) => {
                getClaimDetails().then((resp) => {});
            });
        });
    }, [refreshCounter]);

    useEffect(() => {
        userStore.getCurrentUser().then((response) => {
            userStore.getAllUsers().then((response) => {
                getClaimDetails().then((resp) => {});
            });
        });
    }, []);

    useEffect(() => {
        userStore.getAllUsers().then((response) => {
            getClaimDetails();
        });
    }, [claimId]);

    const onDebitNoteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDebitNoteNumber(e.target.value);
    };
    const onCancelClick = () => {
        navigate("/viewclaims");
    };
    const onCreateOrUpdateClaimHandle = () => {
        if (!selectedAccountManager) {
            setSelectedAccountManagerValid(false);
            return;
        } else {
            if (!claimId) {
                const createClaimRequest: ICreateClaimRequest = {
                    claimType: claimTypeValue,
                    accountManagerId: selectedAccountManager.key,
                    customerAccountNumber: customerAccount,
                    customerOrderRef: customerOrderRef,
                    debitNoteNumber: debitNoteNumber,
                    invoiceDate: invoiceDate,
                    orderDate: orderDate,
                    invoiceNumber: invoiceNumber,
                    salesOrderNumber: salesOrderNumber,
                    currency: claimCurrency,
                };

                claimStore
                    .createClaim(createClaimRequest)
                    .then((response) => {
                        if (response.success) {
                            snackbar.enqueueSnackbar(`Claim created successfully`, {
                                variant: "success",
                            });
                            setClaimId(response.claimId);
                            setIsDetailsActive(true);
                            setIsProductsActive(false);
                            setIsWorkflowActive(false);
                            setIsAuditTrailActive(false);
                            //navigate(`/claimdetails/${response.claimId}`);
                            const refresh = refreshCounter + 1;
                            setRefreshCounter(refresh);
                            onDetailsClick();
                        } else {
                            snackbar.enqueueSnackbar(`${response.message}`, {
                                variant: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
            }
        }
    };

    const [attachments, setAttachements] = useState<any[]>([]);

    useEffect(() => {
        setShowLoader(true);
        claimStore.getAttachementsByClaimId(claimId).then((response) => {
            setAttachements(response.claimAttachments);
            setShowLoader(false);
        });
    }, [isDetailsActive, isProductsActive, isWorkflowActive]);

    const onSaveClaimHandle = () => {
        if (claim?.workflowAccountManagerId != Number(selectedAccountManager.key) || debitNoteNumber != "") {
            claimStore.updateClaimAccountManager(claimId, selectedAccountManager.key, debitNoteNumber as string).then((response) => {
                if (response.success) {
                    const refresh = refreshCounter + 1;
                    setRefreshCounter(refresh);
                    onDetailsClick();
                    snackbar.enqueueSnackbar(`Account manager and Claim updated successfully`, {
                        variant: "success",
                    });
                } else {
                    snackbar.enqueueSnackbar(response.message, {
                        variant: "error",
                    });
                }
            });
        }
    };

    const getAutoCompleteOptions = (users: IUser[]) => {
        return users.map((x) => ({
            label: `${x.name}`,
            key: `${x.userId}`,
        }));
    };

    const onAccountManagerhange = (event: any, value: any) => {
        if (value) {
            setSelectedAccountManager({ key: value.key, label: value.label });
            setSelectedAccountManagerValid(true);
        }
    };

    const onDetailsClick = () => {
        setIsDetailsActive(true);
        setIsProductsActive(false);
        setIsWorkflowActive(false);
        setIsAuditTrailActive(false);
        setShowWorkflowAction(false);
    };

    const onProductsClick = () => {
        CheckCurrentUserActioner();
        CheckCurrentUserRequestor(claim?.raisedByUserId as number).then((resp) => {});
        setIsProductsActive(true);
        setIsDetailsActive(false);
        setIsWorkflowActive(false);
        setIsAuditTrailActive(false);
        setShowWorkflowAction(false);
        setShowProductsLoader(true);
        console.log(isCurentUserRequestor);
        const invoiceLineItemsSearchRequest: IInvoiceLineItemsSearchRequest = { salesOrderNumber: salesOrderNumber, claimId: claimId };
        claimStore.getInvoiceLintemsBySalesOrder(invoiceLineItemsSearchRequest).then((response) => {
            const productLineItems = response.products.map((x: IClaimLineItem) => {
                return {
                    productNumber: x.productNumber,
                    productDescription: x.productDescription,
                    standardCost: x.standardCost,
                    invoicePrice: x.invoicePrice ?? 0,
                    quantity: x.quantity,
                    quantityClaimed: x.quantityClaimed ?? 0,
                    priceClaimed: x.priceClaimed ?? 0,
                    isMarked: x.isMarked,
                    diffPerCase: x.diffPerCase,
                    total: x.total,
                } as IClaimLineItem;
            });
            setProductsLineItems(productLineItems);
            setData({ nodes: productLineItems });

            setShowProductsLoader(false);
        });
    };

    useEffect(() => {
        const productsQtyHigher = data.nodes.filter((x) => x.isClaimedQtyHigher == true);
        setShowQuantityHigherThanInvoiced(productsQtyHigher.length > 0);

        calculateTotalClaimValue();
    }, [data]);

    const [claimWorkflow, setClaimWorkflow] = useState<any>();

    const onWorkflowClick = () => {
        setIsWorkflowActive(true);
        setIsDetailsActive(false);
        setIsProductsActive(false);
        setIsAuditTrailActive(false);
        setShowWorkflowAction(false);

        claimStore.getClaimWorkflow(claimId).then((response) => {
            setClaimWorkflow(response);
        });
    };

    const onAuditClick = () => {
        setIsAuditTrailActive(true);
        setIsProductsActive(false);
        setIsDetailsActive(false);
        setIsWorkflowActive(false);
        setShowWorkflowAction(false);

        setShowAuditLoader(true);
        claimStore.getClaimAudit(claimId).then((response) => {
            setClaimAudit(response.claimAuditEntries);
            setShowAuditLoader(false);
        });
    };

    const onMarkAllClick = () => {
        markAllProducts();
    };

    const onUnmarkAllClick = () => {
        unmarkAllProducts();
    };

    const [showModified, setShowModified] = useState<boolean>(true);

    const [allProducts, setAllProducts] = useState<{ nodes: IClaimLineItem[] }>();

    const onShowModifiedOnly = () => {
        setShowModified(!showModified);

        setAllProducts(data);
        const markedProducts = data.nodes.filter((x) => x.isMarked == true);
        setData({ nodes: markedProducts });
        console.log(data.nodes);
    };

    const onShowAllSKUs = () => {
        setShowModified(!showModified);
        const markedProducts = data.nodes.filter((x) => x.isMarked == true);
        const filterMarkedProducts = allProducts?.nodes.filter((item) => !markedProducts.includes(item));
        const totalProds = [...markedProducts, ...(filterMarkedProducts as IClaimLineItem[])];
        setData({ nodes: totalProds });
    };

    const onAttachmentDeleteClick = (claimAttachementId: number) => {
        setShowLoader(true);
        claimStore
            .removeAttachementByClaimAttachmentId(claimAttachementId)
            .then((response) => {
                if (response.success) {
                    setShowLoader(false);
                    snackbar.enqueueSnackbar("Attachment removed successfully", {
                        variant: "success",
                    });
                    getAttachmentsForClaim();
                }
            })
            .catch((error) => {
                snackbar.enqueueSnackbar("Attachment could not be removed", {
                    variant: "error",
                });
            });
    };

    const onAttachmentDownloadClick = (claimAttachementId: number) => {
        claimStore.getAttachementByClaimAttachmentId(claimAttachementId).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            // Set the file name
            const contentDisposition = response.headers["content-disposition"];
            let fileName = "downloaded-file";

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) {
                    fileName = match[1].trim();
                }
            }

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        });
    };






    const getAttachmentsForClaim = () => {
        setShowAttachmentsLoader(true);
        claimStore.getAttachementsByClaimId(claimId).then((response) => {
            setAttachements(response.claimAttachments);
            setShowAttachmentsLoader(false);
        });
    };

    const getAuditTrailColumns = () => {
        const columns = [
            {
                key: "date",
                name: "Date",
                renderCell: (params: any) => <div>{DateHelper.getShortTextDate(params.row.actionDate, true, false)}</div>,
            },
            {
                key: "user",
                name: "User",
                renderCell: (params: any) => <div>{params.row.user}</div>,
            },
            {
                key: "action",
                name: "Action",
                renderCell: (params: any) => <div>{ClaimAction[params.row.action]}</div>,
            },
            {
                key: "status",
                name: "Status",
                renderCell: (params: any) => <div>{ClaimStatus[params.row.status]}</div>,
            },
            {
                key: "comment",
                name: "Comment/Reason",
                renderCell: (params: any) => <div>{params.row.comment}</div>,
            },
        ];
        return columns;
    };

    const getAttachmentsColumns = () => {
        const columns = [
            {
                key: "download",
                renderCell: (params: any) => (
                    <div>
                        <IoMdDownload className="icons-size-download" onClick={() => onAttachmentDownloadClick(params.row.claimAttachmentId)} />
                    </div>
                ),
            },
            {
                key: "name",
                name: "Name",
                renderCell: (params: any) => <div>{params.row.fileName}</div>,
            },
            {
                key: "created",
                name: "Created",
                renderCell: (params: any) => <div>{DateHelper.getShortTextDate(params.row.uploadDate, true, false)}</div>,
            },
            {
                key: "uploaded",
                name: "Uploaded By",
                renderCell: (params: any) => <div>{params.row.userName}</div>,
            },
            {
                key: "delete",
                renderCell: (params: any) => (
                    <div>
                        {(params.row.userId == userStore.currentUser?.userId || userStore.isCurrentUserApplicationAdmin()) && (
                            <FaTrashAlt className="icons-size-trash" onClick={() => onAttachmentDeleteClick(params.row.claimAttachmentId)} />
                        )}
                    </div>
                ),
            },
        ];
        return columns;
    };

    const handleUpdate = (value: string, productNumber: string, property: string) => {
        setData((state) => ({
            ...state,
            nodes: state.nodes.map((node) => {
                if (node.productNumber === productNumber) {
                    return {
                        ...node,
                        [property]: value,
                    };
                } else {
                    return node;
                }
            }),
        }));
    };

    const handleNumberUpdate = (value: number, productNumber: string, property: string) => {
        setData((state) => ({
            ...state,
            nodes: state.nodes.map((node) => {
                if (node.productNumber === productNumber) {
                    return {
                        ...node,
                        [property]: value,
                    };
                } else {
                    return node;
                }
            }),
        }));
    };

    const updateIsMarked = (value: boolean, productNumber: string) => {
        setData((state) => ({
            ...state,
            nodes: state.nodes.map((node) => {
                if (node.productNumber === productNumber) {
                    return { ...node, ["isMarked"]: value };
                } else {
                    return node;
                }
            }),
        }));
    };

    const updateIsQtyHigherMarked = (value: boolean, productNumber: string) => {
        setData((state) => ({
            ...state,
            nodes: state.nodes.map((node) => {
                if (node.productNumber === productNumber) {
                    return { ...node, ["isClaimedQtyHigher"]: value };
                } else {
                    return node;
                }
            }),
        }));
    };

    const markAllProducts = () => {
        setData((state) => ({
            ...state,
            nodes: state.nodes.map((node) => {
                return { ...node, ["isMarked"]: true, ["priceClaimed"]: node.invoicePrice, ["quantityClaimed"]: node.quantity };
            }),
        }));

        if (claimTypeValue == 2 || claimTypeValue == 3 || claimTypeValue == 4 || claimTypeValue == 5) {
            setTimeout(() => {
                setData((state) => ({
                    ...state,
                    nodes: state.nodes.map((node) => {
                        return { ...node, total: node.isMarked ? node.quantityClaimed * Number(node.invoicePrice) : 0 };
                    }),
                }));
            }, 1500);
        }

        calculateTotalClaimValue();
    };

    const unmarkAllProducts = () => {
        setData((state) => ({
            ...state,
            nodes: state.nodes.map((node) => {
                return { ...node, ["isMarked"]: false, ["priceClaimed"]: 0, ["quantityClaimed"]: 0, ["diffPerCase"]: 0, ["total"]: 0 };
            }),
        }));

        setTimeout(() => {
            setTotalClaimValue(0);
        }, 500);
    };

    const handleClaimedQty = (value: string, productNumber: string, property: string) => {
        handleNumberUpdate(Number(value), productNumber, property);
        switch (claimTypeValue) {
            case ClaimType["Inventory Claim"]:
            case ClaimType["RMA"]:
            case ClaimType["Uplift Request"]:
            case ClaimType["Ad Hoc"]:
                setTimeout(() => {
                    setData((state) => ({
                        ...state,
                        nodes: state.nodes.map((node) => {
                            return {
                                ...node,
                                isClaimedQtyHigher: node.quantityClaimed > node.quantity,
                                total: node.isMarked ? node.quantityClaimed * Number(node.invoicePrice) : 0,
                            };
                        }),
                    }));
                }, 500);
                break;
            case ClaimType["Price Claim"]:
                setTimeout(() => {
                    setData((state) => ({
                        ...state,
                        nodes: state.nodes.map((node) => {
                            return {
                                ...node,
                                isClaimedQtyHigher: node.quantityClaimed > node.quantity,
                                total: node.isMarked ? node.quantityClaimed * Number(node.diffPerCase) : 0,
                            };
                        }),
                    }));
                }, 500);
        }

        calculateTotalClaimValue();
    };

    const [totalClaimValue, setTotalClaimValue] = useState<number>();

    const handleClaimedPrice = (value: string, productNumber: string, property: string) => {
        handleNumberUpdate(Number(value), productNumber, property);

        setTimeout(() => {
            setData((state) => ({
                ...state,
                nodes: state.nodes.map((node) => {
                    return { ...node, diffPerCase: node.isMarked ? node.invoicePrice - Number(node.priceClaimed) : 0 };
                }),
            }));
        }, 500);

        setTimeout(() => {
            setData((state) => ({
                ...state,
                nodes: state.nodes.map((node) => {
                    return { ...node, total: node.isMarked ? node.quantityClaimed * Number(node.diffPerCase) : 0 };
                }),
            }));
        }, 500);

        calculateTotalClaimValue();
    };

    const calculateTotalClaimValue = () => {
        if (data.nodes.length > 0 && data.nodes.filter((x) => x.isMarked == true).length > 0) {
            const totalPrice = data.nodes.reduce((sum, item) => sum + Number(item.total), 0);
            setTimeout(() => {
                setTotalClaimValue(totalPrice);
            }, 500);
        }
    };

    const handleCheckboxSelection = (event: any, productNumber: string, qty: number, invoicePrice: number) => {
        if (event.target.checked) {
            if (claimTypeValue == 1) {
                handleUpdate(String(invoicePrice), productNumber, "priceClaimed");
                handleUpdate(String(qty), productNumber, "quantityClaimed");
                handleUpdate("0", productNumber, "diffPerCase");
                handleUpdate("0", productNumber, "total");
                updateIsMarked(true, productNumber);
            } else {
                handleUpdate(String(invoicePrice), productNumber, "priceClaimed");
                handleUpdate(String(qty), productNumber, "quantityClaimed");
                handleUpdate(String(qty * invoicePrice), productNumber, "total");
                updateIsMarked(true, productNumber);
            }
        } else {
            updateIsMarked(false, productNumber);
            handleUpdate("0", productNumber, "priceClaimed");
            handleUpdate("0", productNumber, "quantityClaimed");
            handleUpdate("0", productNumber, "diffPerCase");
            handleUpdate("0", productNumber, "total");
            updateIsQtyHigherMarked(false, productNumber);
        }

        calculateTotalClaimValue();
    };

    const getCustomTheme = () => ({
        Table: `
            --data-table-library_grid-template-columns: 
            4% 
            7%
            32%
            8%
            8% 
            8%
            8%
            8%
            8%
            9%;
        `,
    });

const theme = useTheme([getCustomTheme()]);

    const getProductsGridcolumns = [
        {
            renderCell: (item: IClaimLineItem) => (
                <input
                    checked={item.isMarked}
                    disabled={claimStatusId > 1}
                    type="checkbox"
                    style={{ width: "40%", border: "none", fontSize: "1rem", padding: 0, margin: 0 }}
                    onChange={(event) => handleCheckboxSelection(event, item.productNumber as string, item.quantity as number, item.invoicePrice as number)}
                />
            ),
        },
        {
            label: "SKU",
            renderCell: (item: IClaimLineItem) => (
                <span style={{ width: "20%", border: "none", fontSize: "1rem", padding: 0, margin: 0 }}>{item.productNumber}</span>
            ),
        },
        {
            label: "Description",
            renderCell: (item: IClaimLineItem) => (
                <span style={{ width: "20%", border: "none", fontSize: "1rem", padding: 0, margin: 0 }}>{item.productDescription}</span>
            ),
            sortable: true,
        },
        
        {
            label: (
                <div style={{ textAlign: "right" }}>
                    Standard<br />Cost
                </div>
            ),
            headerClassName: "right-align-label",
            renderCell: (item: IClaimLineItem) => (
            <span
                style={{
                display: "block", // ensures textAlign works properly
                width: "100%",    // or adjust as needed
                textAlign: "right",
                border: "none",
                fontSize: "1rem",
                padding: 0,
                margin: 0
                }}
            >
                {item.standardCost}
            </span>
            ),
        },

        {
            label: (
                <div style={{ textAlign: "right" }}>
                    Qty
                </div>
            ),
            headerClassName: "right-align-label",
            renderCell: (item: IClaimLineItem) => (
            <span
                style={{
                display: "block", // ensures textAlign works properly
                width: "100%",    // or adjust as needed
                textAlign: "right",
                border: "none",
                fontSize: "1rem",
                padding: 0,
                margin: 0
                }}
            >
                {item.quantity}
            </span>
            ),
        },

        {
            label: (
                <div style={{ textAlign: "right" }}>
                    Case<br/>Price
                </div>
            ),
            headerClassName: "right-align-label",
            renderCell: (item: IClaimLineItem) => (
            <span
                style={{
                display: "block",
                width: "100%",
                textAlign: "right",
                border: "none",
                fontSize: "1rem",
                padding: 0,
                margin: 0
                }}
            >
                {item.invoicePrice}
            </span>
            ),
        },
       
        {
            label: (
                <div style={{ textAlign: "right" }}>
                    Case Qty<br/>Claimed
                </div>
            ),
            headerClassName: "right-align-label",
            renderCell: (item: IClaimLineItem) => (
            <input
                type="text"
                disabled={claimStatusId > 1}
                className={
                item.isMarked
                    ? item.isClaimedQtyHigher
                    ? "form-control error-text"
                    : "form-control"
                    : "unmarked-input"
                }
                style={{
                    display: "block",
                    width: "100%",
                    textAlign: "right",
                    border: "none",
                    fontSize: "1rem",
                    paddingRight:"7px",
                    margin: 0
                }}
                value={item.quantityClaimed == 0 ? "" : item.quantityClaimed}
                onChange={(event) =>
                handleClaimedQty(event.target.value, item.productNumber as string, "quantityClaimed")
                }
            />
            ),
        },

        {
            label: (
                <div style={{ textAlign: "right" }}>
                    Price<br />Claimed
                </div>
            ),
            renderCell: (item: IClaimLineItem) => (
                <>
                    {claimTypeValue == 1 && (
                        <input
                            type="number"
                            disabled={claimStatusId > 1}
                            className={item.isMarked ? "form-control" : "unmarked-input"}
                            style={{
                                display: "block",
                                width: "100%",
                                textAlign: "right",
                                border: "none",
                                fontSize: "1rem",
                                paddingRight: "0px",
                                margin: 0
                            }}
                            value={item.priceClaimed === 0 ? "" : item.priceClaimed}
                            onChange={(event) => handleClaimedPrice(event.target.value, item.productNumber as string, "priceClaimed")}
                        />
                    )}
                    {(claimTypeValue == 2 || claimTypeValue == 3 || claimTypeValue == 4 || claimTypeValue == 5) && (
                        <span
                            style={{
                                display: "block",
                                width: "100%",
                                textAlign: "right",
                                border: "none",
                                fontSize: "1rem",
                                padding: 0,
                                margin: 0
                            }}
                        >
                            {item.priceClaimed === 0 ? "" : item.priceClaimed}
                        </span>
                    )}
                </>
            ),
        },
       
        {
            label: (
                    <div style={{ textAlign: "right" }}>
                        Diff.<br/>Per Case
                    </div>
                ),
            renderCell: (item: IClaimLineItem) => (
                <>
                    {claimTypeValue == 1 && (
                        <span 
                            style={{
                                display: "block",
                                width: "100%",
                                textAlign: "right",
                                border: "none",
                                fontSize: "1rem",
                                padding: 0,
                                margin: 0
                            }}
                        
                        >
                            {item.diffPerCase && <>{item.isMarked ? Number(item.diffPerCase).toFixed(2) : ""}</>}
                        </span>
                    )}
                    {(claimTypeValue == 2 || claimTypeValue == 3 || claimTypeValue == 4 || claimTypeValue == 5) && <></>}
                </>
            ),
        },

        {
            label: (
                <div style={{ textAlign: "right" }}>
                    Total
                </div>
                ),
            renderCell: (item: IClaimLineItem) => (
                <span 
                    style={{
                        display: "block",
                        width: "100%",
                        textAlign: "right",
                        border: "none",
                        fontSize: "1rem",
                        padding: 0,
                        margin: 0
                    }}
                
                >
                    {item.isMarked ? Number(item.total).toFixed(2) : ""}
                </span>
            ),
            
            footer: (
                <div style={{ textAlign: "right" }}>
                    {totalClaimValue && `${claimCurrency}${UiHelper.customMoneyFormatter(totalClaimValue, 2)}`}
                </div>
            ),
        },
    ];

    const checkProductsSelectedAndClaimValue = (): boolean => {
        if (data.nodes.filter((x) => x.isMarked == true).length > 0) {
            if (data.nodes.reduce((sum, item) => Number(sum) + Number(item?.total), 0) > 0) {
                return true;
            } else {
                snackbar.enqueueSnackbar("Claim value is zero. Cannot save zero value claim", {
                    variant: "error",
                });
                return false;
            }
        } else {
            snackbar.enqueueSnackbar("Please select products for claim", {
                variant: "error",
            });
            return false;
        }
    };

    const onSaveProductsClick = () => {
        const products = data.nodes;

        const productsWithClaimId = products.slice().map((item) => ({ ...item, claimId: claimId }));
        if (checkProductsSelectedAndClaimValue()) {
            setShowSubmitLoader(true);
            claimStore
                .saveClaimProducts(productsWithClaimId)
                .then((respone) => {
                    snackbar.enqueueSnackbar("Products saved successfully on the claim", {
                        variant: "success",
                    });
                    setShowSubmitLoader(false);
                })
                .catch((error) => {
                    snackbar.enqueueSnackbar("Error saving products", {
                        variant: "error",
                    });
                    setShowSubmitLoader(false);
                });
        }
    };

    const [showSubmitLoader, setShowSubmitLoader] = useState<boolean | undefined>(undefined);

    const onClaimSubmitClick = () => {
        if (checkProductsSelectedAndClaimValue()) {
            setShowSubmitLoader(true);
            const products = data.nodes;
            const productsWithClaimId = products.slice().map((item) => ({ ...item, claimId: claimId }));
            claimStore
                .submitClaim(claimId, productsWithClaimId)
                .then((response) => {
                    if (response.success) {
                        snackbar.enqueueSnackbar("Claim submitted successfully", {
                            variant: "success",
                        });
                        setShowSubmitLoader(false);
                        //navigate(`/claimdetails/${claimId}`);
                        const refresh = refreshCounter + 1;
                        setRefreshCounter(refresh);
                        onDetailsClick();
                    } else {
                        snackbar.enqueueSnackbar(response.message, {
                            variant: "error",
                        });
                        setShowSubmitLoader(false);
                    }
                })
                .catch((error) => {
                    snackbar.enqueueSnackbar("Error submitting claim", {
                        variant: "error",
                    });
                    setShowSubmitLoader(false);
                });
        }
    };

    const [showResetConfirmationModal, setShowResetConfirmationModal] = useState<boolean>(false);

    const onResetClick = () => {
        setShowResetConfirmationModal(true);
    };

    const onResetConfirmationCancel = () => {
        setShowResetConfirmationModal(false);
    };

    const onResetConfirmationYes = () => {
        const claimResetRequest = {
            claimId: claimId,
            claimStatusId: ClaimStatus["Draft"],
            claimActionId: ClaimAction["Reset Claim"],
        };

        claimStore
            .updateClaimStatusWithComment(claimResetRequest)
            .then((response) => {
                if (response.success) {
                    snackbar.enqueueSnackbar("Claim reset successfully", {
                        variant: "success",
                    });

                    // navigate(`/claimdetails/${claimId}`);
                    const refresh = refreshCounter + 1;
                    setRefreshCounter(refresh);
                    onDetailsClick();
                }
            })
            .catch((error) => {
                snackbar.enqueueSnackbar("Error resetting claim", {
                    variant: "error",
                });
            });
    };

    const [showWorkflowAction, setShowWorkflowAction] = useState<boolean>(false);
    const [workflowActionName, setWorkflowActionName] = useState<
        "Set as Valid" | "Cancel" | "Set as Invalid" | "Set Part Valid" | "Reject" | "Approve" | "Write Off"
    >();
    const [workflowActionComments, setWorkflowActionComments] = useState<string>();
    const [reasonCodes, setReasonCodes] = useState<any[]>([]);
    const [selectedReasonCode, setSelectedReasonCode] = useState<any>();

    function removeDuplicates(arr: any[], key: string): any[] {
        return arr.reduce((unique, item) => {
            // Check if the current object has the specified key
            if (item.hasOwnProperty(key)) {
                // Check if there is no existing object with the same key value
                if (!unique.some((obj: any) => obj[key] === item[key])) {
                    unique.push(item);
                }
            } else {
                // If the key doesn't exist in the current object, always include it in the unique array
                unique.push(item);
            }
            return unique;
        }, []);
    }

    const getReasonCodesOptions = (reasonCodes: any[]) => {
        const reasonCodesWithoutDeuplicates = removeDuplicates(reasonCodes, "reasonDescription");
        return reasonCodesWithoutDeuplicates.map((x) => ({
            label: `${x.reasonDescription}`,
            key: `${x.reasonCode}`,
        }));
    };

    const onReasonCodeChange = (event: any, value: any) => {
        console.log(value);
        if (value) {
            setSelectedReasonCode({ key: value.key, label: value.label });
        }
    };

    const onCancelClaimClick = () => {
        setWorkflowActionName("Cancel");
        setShowWorkflowAction(true);
        setIsAuditTrailActive(false);
        setIsProductsActive(false);
        setIsDetailsActive(false);
        setIsWorkflowActive(false);
    };

    const onClaimSetValidClick = () => {
        setWorkflowActionName("Set as Valid");
        setShowWorkflowAction(true);
        setIsAuditTrailActive(false);
        setIsProductsActive(false);
        setIsDetailsActive(false);
        setIsWorkflowActive(false);
        console.log(claimTypeValue);
        claimStore.getClaimCreditReasonCodes().then((response) => {
            setReasonCodes(response.reasonCodes);
        });
        if (claimTypeValue == 5) {
            setSelectedReasonCode({ key: "FINBADDEBT", label: "FINANCE BAD DEBT WRITE OFF" });
        }
    };

    const onClaimSetInvalidClick = () => {
        setWorkflowActionName("Set as Invalid");
        setShowWorkflowAction(true);
        setIsAuditTrailActive(false);
        setIsProductsActive(false);
        setIsDetailsActive(false);
        setIsWorkflowActive(false);
    };

    const onClaimSetPartValidClick = () => {
        setWorkflowActionName("Set Part Valid");
        setShowWorkflowAction(true);
        setIsAuditTrailActive(false);
        setIsProductsActive(false);
        setIsDetailsActive(false);
        setIsWorkflowActive(false);
    };

    const onClaimWriteOffClick = () => {
        setWorkflowActionName("Write Off");
        setShowWorkflowAction(true);
        setIsAuditTrailActive(false);
        setIsProductsActive(false);
        setIsDetailsActive(false);
        setIsWorkflowActive(false);
    };

    const onClaimValidSubmitClick = () => {
        var needCreditReason: boolean = false;
        if (
            (claimTypeValue == ClaimType["Ad Hoc"] ||
                claimTypeValue == ClaimType["Inventory Claim"] ||
                claimTypeValue == ClaimType["RMA"] ||
                claimTypeValue == ClaimType["Uplift Request"] ||
                claimTypeValue == ClaimType["Price Claim"]) &&
            claimStatusId == 2
        ) {
            needCreditReason = true;
        }

        if (
            (claimTypeValue == ClaimType["Ad Hoc"] ||
                claimTypeValue == ClaimType["Inventory Claim"] ||
                claimTypeValue == ClaimType["RMA"] ||
                claimTypeValue == ClaimType["Uplift Request"] ||
                claimTypeValue == ClaimType["Price Claim"]) &&
            claimStatusId == 2
        ) {
            if (!selectedReasonCode) {
                setIsReasonCodeSelected(false);
                return;
            }

            if (!workflowActionComments) {
                setShowWorkflowActionCommentsError(true);
                return;
            }
        }

        const claimSetValidAndCommentRequest = {
            claimId: claimId,
            claimStatusId: ClaimStatus["Pending Approval"],
            claimActionId: ClaimAction["Set As Valid"],
            creditReasonCode: needCreditReason ? selectedReasonCode.key : null,
            creditReason: needCreditReason ? selectedReasonCode.label : null,
            comments: workflowActionComments,
        };
        setWorkflowActionInprogress(true);
        claimStore
            .updateClaimStatusWithComment(claimSetValidAndCommentRequest)
            .then((response) => {
                if (response.success) {
                    snackbar.enqueueSnackbar("Claim updated successfully", {
                        variant: "success",
                    });
                }

                setTimeout(() => {
                    //navigate(`/claimdetails/${claimId}`);
                    const refresh = refreshCounter + 1;
                    setRefreshCounter(refresh);
                    onDetailsClick();
                }, 3000);

                setWorkflowActionInprogress(false);
            })
            .catch((error) => {
                snackbar.enqueueSnackbar("Error updating claim", {
                    variant: "error",
                });
                setWorkflowActionInprogress(false);
            });
    };

    const onClaimInvalidSubmitClick = () => {
        if (!workflowActionComments) {
            setShowWorkflowActionCommentsError(true);
            return;
        }

        const claimActionAndCommentRequest = {
            claimId: claimId,
            claimStatusId: ClaimStatus.Invalid,
            claimActionId: ClaimAction["Set As Invalid"],
            comments: workflowActionComments,
        };
        setWorkflowActionInprogress(true);
        claimStore
            .updateClaimStatusWithComment(claimActionAndCommentRequest)
            .then((response) => {
                if (response.success) {
                    snackbar.enqueueSnackbar("Claim updated successfully", {
                        variant: "success",
                    });

                    setTimeout(() => {
                        //navigate(`/claimdetails/${claimId}`);
                        const refresh = refreshCounter + 1;
                        setRefreshCounter(refresh);
                        onDetailsClick();
                    }, 3000);
                }
                setWorkflowActionInprogress(false);
            })
            .catch((error) => {
                snackbar.enqueueSnackbar("Error updating claim", {
                    variant: "error",
                });
                setWorkflowActionInprogress(false);
            });
    };

    const onClaimPartValidSubmitClick = () => {
        if (!workflowActionComments) {
            setShowWorkflowActionCommentsError(true);
            return;
        }
        const claimActionAndCommentRequest = {
            claimId: claimId,
            claimStatusId: ClaimStatus.PartValid,
            claimActionId: ClaimAction["Part Valid"],
            comments: workflowActionComments,
        };
        setWorkflowActionInprogress(true);
        claimStore
            .updateClaimStatusWithComment(claimActionAndCommentRequest)
            .then((response) => {
                if (response.success) {
                    snackbar.enqueueSnackbar("Claim updated successfully", {
                        variant: "success",
                    });
                    setTimeout(() => {
                        //navigate(`/claimdetails/${claimId}`);
                        const refresh = refreshCounter + 1;
                        setRefreshCounter(refresh);
                        onDetailsClick();
                    }, 3000);
                    setWorkflowActionInprogress(false);
                }
            })
            .catch((error) => {
                snackbar.enqueueSnackbar("Error updating claim", {
                    variant: "error",
                });
                setWorkflowActionInprogress(false);
            });
    };

    const onClaimActionCancelClick = () => {
        onProductsClick();
    };

    const onClaimCancelSubmitClick = () => {
        if (!workflowActionComments) {
            setShowWorkflowActionCommentsError(true);
            return;
        } else {
            setShowWorkflowActionCommentsError(false);
        }

        const claimCancelledRequest = {
            claimId: claimId,
            claimStatusId: ClaimStatus["Cancelled"],
            claimActionId: ClaimAction["Cancel Claim"],
            comments: workflowActionComments,
        };
        setWorkflowActionInprogress(true);
        claimStore
            .updateClaimStatusWithComment(claimCancelledRequest)
            .then((response) => {
                if (response.success) {
                    snackbar.enqueueSnackbar("Claim cancelled successfully", {
                        variant: "success",
                    });
                    setWorkflowActionInprogress(false);
                }
            })
            .catch((error) => {
                snackbar.enqueueSnackbar("Error cancelling claim", {
                    variant: "error",
                });
                setWorkflowActionInprogress(false);
            });
        const refresh = refreshCounter + 1;
        setRefreshCounter(refresh);
        onDetailsClick();
    };

    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const rejectfileInputRef = useRef<HTMLInputElement | null>(null);

    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const [selectedRejectFile, setSelectedRejectFile] = useState<File | null>(null);

    const clearFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Reset the file input value
        }
        setSelectedFile(null); // Clear the state
    };

    useEffect(() => {
        if (selectedFile != null) {
            const formData = new FormData();
            formData.append("claimId", JSON.stringify(claimId));
            const files: File[] = [selectedFile as File];
            console.log(files);
            ApiHelper.postMultiPartData("Claim/addattachment", formData, files)
                .then((response) => {
                    snackbar.enqueueSnackbar("Attachment uploaded successfully", {
                        variant: "success",
                    });
                    getAttachmentsForClaim();
                })
                .catch((error) => {
                    snackbar.enqueueSnackbar("Error uploading the attachment", {
                        variant: "error",
                    });
                });

            clearFileInput();
        }
    }, [selectedFile]);

    useEffect(() => {
        if (selectedRejectFile != null) {
            const formData = new FormData();
            formData.append("claimId", JSON.stringify(claimId));
            const files: File[] = [selectedRejectFile as File];
            console.log(files);
            ApiHelper.postMultiPartData("Claim/addattachment", formData, files)
                .then((response) => {
                    snackbar.enqueueSnackbar("Attachment uploaded successfully", {
                        variant: "success",
                    });
                    setShowWorkflowAttachmentUploadSuccess(true);
                    setWorkflowAttachmentUploadSuccessMessage(workflowAttachmentUploadSuccessMessage + "\n" + files[0].name);
                })
                .catch((error) => {
                    snackbar.enqueueSnackbar("Error uploading the attachment", {
                        variant: "error",
                    });
                    setShowWorkflowAttachmentUploadSuccess(false);
                });

            clearRejectFileInput();
            setShowWorkflowActionAttachmentError(false);
        }
    }, [selectedRejectFile]);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setSelectedFile(event.target.files[0]);
        }
    };

    const handleAddAttachmentClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click(); // Programmatically open file selection dialog
        }
    };

    const [isCurentUserActioner, setIsCurrentUserActioner] = useState<boolean>(false);

    const CheckCurrentUserActioner = (): void => {
        userStore.getCurrentUser().then((currentUserResponse) => {
            if (claim?.actionerUserId) {
                userStore.getUserByIdPromise(claim?.actionerUserId as number).then((actionerUserResponse) => {
                    setIsCurrentUserActioner(
                        currentUserResponse.user?.userId === claim?.actionerUserId ||
                            currentUserResponse.user?.userId == actionerUserResponse.user?.delegationUserId
                    );
                });
            } else {
                setIsCurrentUserActioner(false);
            }
        });
    };

    const [isCurentUserRequestor, setIsCurentUserRequestor] = useState<boolean | undefined>(undefined);

    const CheckCurrentUserRequestor = async (claimRequestorId: number): Promise<any> => {
        userStore.getCurrentUser().then((response) => {
            setIsCurentUserRequestor(response.user?.userId === claimRequestorId);
        });
    };

    const clearWorkflowActionState = () => {
        setWorkflowAttachmentUploadSuccessMessage("");
        setShowWorkflowAttachmentUploadSuccess(false);
        setShowWorkflowActionAttachmentError(false);
        setWorkflowActionComments("");
    };

    const onClaimRejectClick = () => {
        setWorkflowActionName("Reject");
        clearWorkflowActionState();
        setShowWorkflowAction(true);
        setIsAuditTrailActive(false);
        setIsProductsActive(false);
        setIsDetailsActive(false);
        setIsWorkflowActive(false);
    };

    const [isReasonCodeSelected, setIsReasonCodeSelected] = useState<boolean | undefined>(true);

    const onClaimApproveClick = () => {
        setWorkflowActionName("Approve");
        clearWorkflowActionState();
        setShowWorkflowAction(true);
        setIsAuditTrailActive(false);
        setIsProductsActive(false);
        setIsDetailsActive(false);
        setIsWorkflowActive(false);

        claimStore.getClaimCreditReasonCodes().then((response) => {
            setReasonCodes(response.reasonCodes);
        });
    };

    const onClaimApproveSubmitClick = () => {
        if (!workflowActionComments) {
            setShowWorkflowActionCommentsError(true);
            return;
        }
        const claimApprovedWithReasonCodeRequest = {
            claimId: claimId,
            claimStatusId: ClaimStatus["Approved"],
            claimActionId: ClaimAction["Approve"],
            comments: workflowActionComments,
        };
        setWorkflowActionInprogress(true);
        claimStore
            .updateClaimStatusWithComment(claimApprovedWithReasonCodeRequest)
            .then((response) => {
                if (response.success) {
                    snackbar.enqueueSnackbar("Claim Approved successfully", {
                        variant: "success",
                    });
                    setWorkflowActionInprogress(false);
                }
            })
            .catch((error) => {
                snackbar.enqueueSnackbar("Error approving claim", {
                    variant: "error",
                });
                setWorkflowActionInprogress(false);
            });

        //navigate(`/claimdetails/${claimId}`);
        const refresh = refreshCounter + 1;
        setRefreshCounter(refresh);
        onDetailsClick();
    };

    const handleAddRejectAttachmentClick = () => {
        if (rejectfileInputRef.current) {
            rejectfileInputRef.current.click(); // Programmatically open file selection dialog
        }
    };

    const clearRejectFileInput = () => {
        if (rejectfileInputRef.current) {
            rejectfileInputRef.current.value = ""; // Reset the file input value
        }
        setSelectedRejectFile(null); // Clear the state
    };

    const handleRejectFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setSelectedRejectFile(event.target.files[0]);
        }
    };

    const [showWorkflowActionAttachmentError, setShowWorkflowActionAttachmentError] = useState<boolean | undefined>(false);

    const [showWorkflowActionCommentsError, setShowWorkflowActionCommentsError] = useState<boolean | undefined>(false);

    const onClaimRejectSubmitClick = () => {
        if (workflowAttachmentUploadSuccessMessage == "") {
            setShowWorkflowActionAttachmentError(true);
            return;
        } else {
            setShowWorkflowActionAttachmentError(false);
        }
        if (!workflowActionComments) {
            setShowWorkflowActionCommentsError(true);
            return;
        } else {
            setShowWorkflowActionCommentsError(false);
        }

        const claimApprovedWithReasonCodeRequest = {
            claimId: claimId,
            claimStatusId: ClaimStatus["Rejected"],
            claimActionId: ClaimAction["Reject"],
            comments: workflowActionComments,
        };
        setWorkflowActionInprogress(true);
        claimStore
            .updateClaimStatusWithComment(claimApprovedWithReasonCodeRequest)
            .then((response) => {
                if (response.success) {
                    snackbar.enqueueSnackbar("Claim rejected successfully", {
                        variant: "success",
                    });
                    setWorkflowActionInprogress(false);
                }
            })
            .catch((error) => {
                snackbar.enqueueSnackbar("Error rejecting claim", {
                    variant: "error",
                });
                setWorkflowActionInprogress(false);
            });
        //navigate(`/claimdetails/${claimId}`);
        const refresh = refreshCounter + 1;
        setRefreshCounter(refresh);
        onDetailsClick();
    };

    const [showWorkflowAttachmentUploadSuccess, setShowWorkflowAttachmentUploadSuccess] = useState<boolean>(false);
    const [workflowAttachmentUploadSuccessMessage, setWorkflowAttachmentUploadSuccessMessage] = useState<string>("");

    const [showCommentModal, setShowCommentModal] = useState<boolean | undefined>(undefined);

    const [showCommentsLoader, setShowCommentsLoader] = useState<boolean | undefined>(undefined);

    const [newComment, setNewComment] = useState<string>("");

    const [newCommentAdded, setNewCommentAdded] = useState<string>("");

    const [showNewCommentError, setShowNewCommentError] = useState<boolean | undefined>(undefined);

    const [comments, setComments] = useState<IComment[]>([]);

    const [selectedNotify, setSelectedNotify] = useState<any[]>([]);

    const onNotifyUserChange = (event: any, value: any) => {
        setSelectedNotify(value);
    };

    useEffect(() => {
        loadComments();
    }, [newCommentAdded]);

    const onCommentSaveClick = () => {
        if (!newComment) {
            setShowNewCommentError(true);
            return;
        } else {
            setShowNewCommentError(false);
            const notifyUsers: IUser[] = selectedNotify.map((x) => ({
                userId: x.key,
                name: x.label,
            }));

            claimStore
                .saveComment(claimId, notifyUsers, newComment)
                .then((resp) => {
                    if (resp.success) {
                        snackbar.enqueueSnackbar("Comment saved successfully", {
                            variant: "success",
                        });
                    }
                    setNewCommentAdded(newComment);
                })
                .catch((error) => {
                    snackbar.enqueueSnackbar("Error saving comment", {
                        variant: "error",
                    });
                });

            setShowCommentModal(false);
        }
    };

    const getCommentsColumns = () => {
        const columns = [
            {
                key: "commentDate",
                name: "Comment Date",
                renderCell: (params: any) => <div>{DateHelper.getShortTextDate(params.row.commentDate, true, false)}</div>,
            },
            {
                key: "user",
                name: "User",
                renderCell: (params: any) => <div>{params.row.user}</div>,
            },
            {
                key: "comment",
                name: "Comment",
                renderCell: (params: any) => <div>{params.row.comment}</div>,
            },
        ];
        return columns;
    };

    const [workflowActionInprogress, setWorkflowActionInprogress] = useState<boolean>(false);

    return (
        <div className="container-fluid p-1">
            <div className="m-4 card">
                {isClaimDetailsLoaded && (
                    <div className="card-header">
                        <div className="row m-0">
                            <ul className="nav nav-tabs card-header-tabs col-sm-6">
                                <li className="nav-item">
                                    <a className={isDetailsActive ? "nav-link active" : "nav-link"} onClick={onDetailsClick} href="#">
                                        Details
                                    </a>
                                </li>
                                {Number(claimId) != 0 && (
                                    <>
                                        <li className="nav-item">
                                            <a className={isProductsActive ? "nav-link active" : "nav-link"} onClick={onProductsClick} href="#">
                                                Products
                                            </a>
                                        </li>
                                        {showWorkflowAction && (
                                            <li className="nav-item">
                                                <a className={showWorkflowAction ? "nav-link active" : "nav-link"} href="#">
                                                    Workflow Action
                                                </a>
                                            </li>
                                        )}
                                        <li className="nav-item">
                                            <a className={isWorkflowActive ? "nav-link active" : "nav-link"} onClick={onWorkflowClick} href="#">
                                                Workflow
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={isAuditTrailActive ? "nav-link active" : "nav-link"} onClick={onAuditClick} href="#">
                                                Audit Trail
                                            </a>
                                        </li>
                                    </>
                                )}
                            </ul>
                            <div className="col-sm-6 text-right font-weight-bold align-content-center">
                                <p className="text-end margin-bottom-0">
                                    {claimRef ? claimRef : "New"} {claimType} - {customerAccount} {claimId ? `(${claimStatus})` : ""}
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                {isDetailsActive && isClaimDetailsLoaded && (
                    <div className="col-12 card-body">
                        <form>
                            <div className="form-row m-1">
                                <div className="form-group row pb-2">
                                    <div className="col-md-2">
                                        <label htmlFor="claimtype" className="col-form-label">
                                            Customer Account
                                        </label>
                                    </div>
                                    <div className="col-md-4">
                                        <input
                                            type="name"
                                            className="form-control"
                                            name="customerAccount"
                                            required
                                            value={customerAccount}
                                            disabled={true}
                                            id="customerAccount"
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="col-form-label">Invoice Date</label>
                                    </div>

                                    <div className="col-md-4">
                                        <input
                                            type="name"
                                            name="invoiceDate"
                                            className="form-control"
                                            required
                                            value={DateHelper.getShortTextDate(invoiceDate)}
                                            disabled
                                            id="invoiceDate"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row m-1">
                                <div className="form-group row pb-2">
                                    <div className="col-md-2">
                                        <label htmlFor="claimtype" className="col-form-label">
                                            Order Date
                                        </label>
                                    </div>
                                    <div className="col-md-4">
                                        <input
                                            type="name"
                                            name="orderDate"
                                            className="form-control"
                                            required
                                            value={DateHelper.getShortTextDate(orderDate)}
                                            disabled={true}
                                            id="orderDate"
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="col-form-label">Sales Order Number</label>
                                    </div>
                                    <div className="col-md-4">
                                        <input
                                            type="name"
                                            name="salesOrderNumber"
                                            disabled
                                            required
                                            value={salesOrderNumber}
                                            className="form-control"
                                            id="salesOrderNumber"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row m-1">
                                <div className="form-group row pb-2">
                                    <div className="col-md-2">
                                        <label htmlFor="claimtype" className="col-form-label">
                                            Customer Order Ref
                                        </label>
                                    </div>
                                    <div className="col-md-4">
                                        <input
                                            type="name"
                                            name="orderDate"
                                            className="form-control"
                                            required
                                            value={customerOrderRef}
                                            disabled={true}
                                            id="orderDate"
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <label className="col-form-label">Invoice Number</label>
                                    </div>
                                    <div className="col-md-4">
                                        <input
                                            type="name"
                                            name="customerOrderNumber"
                                            disabled
                                            required
                                            value={invoiceNumber}
                                            className="form-control"
                                            id="customerOrderNumber"
                                        />
                                    </div>
                                </div>
                            </div>
                            {claimTypeValue != ClaimType["Ad Hoc"] && (
                                <div className="form-row m-1">
                                    <div className="form-group row pb-2">
                                        <div className="col-md-2">
                                            <label htmlFor="claimtype" className="col-form-label">
                                                Credit Note Number
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <input
                                                type="name"
                                                name="orderDate"
                                                className="form-control"
                                                required
                                                value={creditNoteNumber}
                                                disabled={true}
                                                id="orderDate"
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="col-form-label">{rmaLabel}</label>
                                        </div>
                                        <div className="col-md-4">
                                            <input
                                                type="name"
                                                name="customerOrderNumber"
                                                disabled
                                                required
                                                value={rmaValue}
                                                className="form-control"
                                                id="customerOrderNumber"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="form-row m-1">
                                <div className="form-group row pb-2">
                                    <div className="col-md-2">
                                        <label htmlFor="claimtype" className="col-form-label">
                                            Debit Note Number
                                        </label>
                                    </div>

                                    <div className="col-md-4">
                                        <input
                                            type="name"
                                            name="debitNoteNumber"
                                            disabled={Number(claimStatusId) <= 2 ? false : true}
                                            value={debitNoteNumber}
                                            required
                                            onChange={onDebitNoteChange}
                                            className="form-control"
                                            id="debitNoteNumber"
                                        />
                                    </div>

                                    <div className="col-md-2">
                                        <label htmlFor="claimtype" className="col-form-label">
                                            Account Manager
                                        </label>
                                    </div>
                                    <div className="col-md-4">
                                        {(claimStatusId as number) > 2 && (
                                            <input
                                                type="name"
                                                name="accountManager"
                                                disabled
                                                value={accountManagerName}
                                                required
                                                className="form-control"
                                                id="accountManager"
                                            />
                                        )}
                                        {(claimStatusId == 1 || claimStatusId == 2 || !claimStatusId) && userStore.users && (
                                            <CustomAutoComplete
                                                selectedValue={selectedAccountManager}
                                                onChange={(event: any, value: any) => onAccountManagerhange(event, value)}
                                                id="selectAccountManagerr"
                                                defaultValue={{ key: "", label: "Select Account Manager" }}
                                                options={getAutoCompleteOptions(userStore.users)}
                                                showError={!isSelectedAccountManagerValid}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="form-row m-1">
                                <div className="form-group row pb-2">
                                    <div className="col-md-2">
                                        <label htmlFor="claimtype" className="col-form-label">
                                            Credit Reason
                                        </label>
                                    </div>
                                    <div className="col-md-4">
                                        <input type="name" name="creditReason" disabled value={creditReason} className="form-control" id="creditReason" />
                                    </div>
                                    <div className="col-md-2"></div>
                                    <div className="col-md-4"></div>
                                </div>
                            </div>
                            {claimId == 0 && claimExitsForInvoice && (
                                <div className="form-group row">
                                    <div className="col-md-6">
                                        <div className="alert alert-danger mt-4 alert-dismissible fade show">
                                            <strong>Warning!</strong> One or more claims already exist for this invoice. Claim ref: {invoice?.claimId}
                                            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="form-group row mt-3">
                                <div className="col-md-12">
                                    {claimId == 0 && (
                                        <button className="btn btn-primary" onClick={onCreateOrUpdateClaimHandle} type="button">
                                            Create
                                        </button>
                                    )}
                                    {claimId > 0 && isCurentUserRequestor && (
                                        <button className="btn btn-primary" disabled={(claimStatusId as number) > 2} onClick={onSaveClaimHandle} type="button">
                                            Save
                                        </button>
                                    )}
                                    <a className="btn btn-primary ms-1" onClick={onCancelClick}>
                                        Cancel
                                    </a>
                                </div>
                            </div>
                        </form>
                    </div>
                )}
                {isProductsActive && (
                    <>
                        {!showSubmitLoader && (
                            <div className="col-12 card-body">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="row m-0">
                                            <div className="col-sm-7 align-content-center">
                                                <span>Product Details</span>
                                            </div>
                                            {claimStatusId == 1 && (
                                                <div className="col-sm-5 justify-content-end align-content-end text-end">
                                                    {" "}
                                                    <button className="btn btn-primary me-1 btn-sm" onClick={onMarkAllClick} type="button">
                                                        Mark All
                                                    </button>
                                                    <button className="btn btn-primary me-1 btn-sm" onClick={onUnmarkAllClick} type="button">
                                                        Unmark All
                                                    </button>
                                                    {showModified && (
                                                        <button className="btn btn-primary btn-sm" onClick={onShowModifiedOnly} type="button">
                                                            Show Modified Only
                                                        </button>
                                                    )}
                                                    {!showModified && (
                                                        <button className="btn btn-primary btn-sm" onClick={onShowAllSKUs} type="button">
                                                            Show All SKUs
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row card-body w-100 h-100">
                                        <div className="col table-responsive p-2 grid-parent-container">
                                            {showProductsLoader && <Spinner />}
                                            {!showProductsLoader && productLineItems.length > 0 && (
                                                <CompactTable columns={getProductsGridcolumns} 
                                                data={data} 
                                                theme={theme} 
                                                layout={{
                                                    custom: true,
                                                    gridTemplateColumns: "minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr) minmax(0px, 1fr)"
                                                }}

                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-md-12 ms-2 p-2">
                                            {claimStatusId == 1 && (isCurentUserRequestor || userStore.isCurrentUserApplicationAdmin()) && (
                                                <button
                                                    disabled={showQuantityHigherThanInvoiced}
                                                    className="btn btn-primary m-1"
                                                    onClick={onSaveProductsClick}
                                                    type="button"
                                                >
                                                    Save
                                                </button>
                                            )}
                                            {claimStatusId == 1 &&  (isCurentUserRequestor || userStore.isCurrentUserApplicationAdmin()) && (
                                                <button
                                                    disabled={showQuantityHigherThanInvoiced}
                                                    className="btn btn-primary m-1"
                                                    onClick={onClaimSubmitClick}
                                                    type="button"
                                                >
                                                    Submit
                                                </button>
                                            )}
                                            {(claimStatusId == 2 || claimStatusId == 3) && isCurentUserActioner && (
                                                <>
                                                    <button className="btn btn-primary m-1" onClick={onClaimSetValidClick} type="button">
                                                        Set Valid
                                                    </button>
                                                    <button className="btn btn-primary m-1" onClick={onClaimSetInvalidClick} type="button">
                                                        Set Invalid
                                                    </button>
                                                    <button className="btn btn-primary m-1" onClick={onClaimSetPartValidClick} type="button">
                                                        Set Part Valid
                                                    </button>
                                                </>
                                            )}
                                            {claimStatusId == 4 && (isCurentUserRequestor || userStore.isCurrentUserApplicationAdmin()) && (
                                                <button className="btn btn-primary m-1" onClick={onClaimWriteOffClick} type="button">
                                                    Write Off
                                                </button>
                                            )}
                                            {(isCurentUserRequestor || (isCurentUserActioner && claimStatusId == 2)) &&
                                                (claimStatusId == 2 || claimStatusId == 4 || claimStatusId == 5 || claimStatusId == 8) && (
                                                    <button className="btn btn-primary m-1" onClick={onResetClick} type="button">
                                                        Reset
                                                    </button>
                                                )}

                                            {showResetConfirmationModal && (
                                                <ConfirmationModal
                                                    onYesClick={onResetConfirmationYes}
                                                    onCancelClick={onResetConfirmationCancel}
                                                    modalText="Are you sure you want to reset the claim?"
                                                    modalTitle="Reset Claim"
                                                />
                                            )}
                                            {claimStatusId == 6 && isCurentUserActioner && (
                                                <>
                                                    <button className="btn btn-primary m-1" onClick={onClaimApproveClick} type="button">
                                                        Approve
                                                    </button>
                                                    <button className="btn btn-primary m-1" onClick={onClaimRejectClick} type="button">
                                                        Reject
                                                    </button>
                                                </>
                                            )}
                                            {(isCurentUserRequestor || userStore.isCurrentUserApplicationAdmin() || (isCurentUserActioner && claimStatusId == 2)) && (
                                                <button className="btn btn-primary m-1" onClick={onCancelClaimClick}>
                                                    Cancel
                                                </button>
                                            )}
                                            {showQuantityHigherThanInvoiced && (
                                                <>
                                                    <span className="error-text">Quantity claimed cannot be larger than invoice quantity</span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {showSubmitLoader && <Spinner />}
                    </>
                )}
                {showWorkflowAction && (
                    <div className="col-12 card-body">
                        <form>
                            <div className="form-group row m-1">
                                <div className="col-md-2">
                                    <label className="col-form-label">Workflow Action</label>
                                </div>
                                <div className="col-md-8">
                                    <label className="col-form-label">{workflowActionName}</label>
                                </div>
                            </div>
                            {workflowActionName != "Cancel" && (
                                <div className="form-group row m-1">
                                    <div className="col-md-2">
                                        <label className="col-form-label"></label>
                                    </div>
                                    {(workflowActionName == "Set Part Valid" || workflowActionName == "Set as Invalid") && (
                                        <div className="col-md-8">
                                            <div>
                                                Setting claim as <b>Part Valid</b> sends the claim back to the requestor and allows them to modify and resubmit.
                                            </div>
                                            <div>
                                                Setting claim as <b>Invalid</b> marks the claim as invalid and closes it.
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            {(((claimTypeValue == 2 || claimTypeValue == 3 || claimTypeValue == 4 || claimTypeValue == 5) &&
                                workflowActionName == "Set as Valid") ||
                                (claimTypeValue == 1 && workflowActionName == "Set as Valid" && claimStatusId == 2) ||
                                (claimStatusId == 4 && workflowActionName == "Write Off")) && (
                                <div className="form-group row m-1">
                                    <div className="col-md-2">
                                        <label className="col-form-label">Credit Reason</label>
                                    </div>
                                    <div className="col-md-8">
                                        {claimTypeValue != 5 && (
                                            <CustomAutoComplete
                                                selectedValue={selectedReasonCode}
                                                onChange={(event: any, value: any) => onReasonCodeChange(event, value)}
                                                id="selectCreditReasonCode"
                                                defaultValue={{ key: "", label: "Select Reason Code" }}
                                                options={getReasonCodesOptions(reasonCodes)}
                                                showError={!isReasonCodeSelected}
                                            />
                                        )}
                                        {claimTypeValue == 5 && <label className="col-form-label">{selectedReasonCode.label}</label>}
                                    </div>
                                </div>
                            )}
                            <div className="form-group row m-1">
                                <div className="col-md-2">
                                    <label className="col-form-label">Comments</label>
                                </div>
                                <div className="col-md-8">
                                    <textarea
                                        rows={5}
                                        className={showWorkflowActionCommentsError ? "form-control is-invalid" : "form-control"}
                                        onChange={(event) => setWorkflowActionComments(event.target.value)}
                                        value={workflowActionComments}
                                    ></textarea>
                                </div>
                            </div>
                            {(workflowActionName == "Reject" || workflowActionName == "Set as Invalid") && (
                                <div className="form-group row m-1">
                                    <div className="col-md-2">
                                        <label className="col-form-label">Supporting Evidence</label>
                                    </div>
                                    <div className="col-md-8">
                                        <input
                                            onChange={handleRejectFileChange}
                                            ref={rejectfileInputRef}
                                            type="file"
                                            style={{ display: "none" }}
                                            multiple
                                            name="attachments"
                                        />
                                        <button className="btn btn-primary me-1 btn-sm" onClick={handleAddRejectAttachmentClick} type="button">
                                            Add Attachment
                                        </button>
                                        {showWorkflowActionAttachmentError && <span className="error-text">Please select an attachment as evidence</span>}
                                        {showWorkflowAttachmentUploadSuccess && (
                                            <div className="alert alert-success" role="alert">
                                                {workflowAttachmentUploadSuccessMessage}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                            <div className="form-group row">
                                {!workflowActionInprogress && (
                                    <div className="col-md-12 ms-2 p-2">
                                        {workflowActionName == "Set as Valid" && (
                                            <button className="btn btn-primary m-1" onClick={onClaimValidSubmitClick} type="button">
                                                Set Valid
                                            </button>
                                        )}
                                        {workflowActionName == "Cancel" && (
                                            <button className="btn btn-primary m-1" onClick={onClaimCancelSubmitClick} type="button">
                                                Cancel Claim
                                            </button>
                                        )}

                                        {workflowActionName == "Set as Invalid" && (
                                            <button className="btn btn-primary m-1" onClick={onClaimInvalidSubmitClick} type="button">
                                                Set Invalid
                                            </button>
                                        )}
                                        {workflowActionName == "Set Part Valid" && (
                                            <button className="btn btn-primary m-1" onClick={onClaimPartValidSubmitClick} type="button">
                                                Set Part Valid
                                            </button>
                                        )}
                                        {workflowActionName == "Approve" && (
                                            <button className="btn btn-primary m-1" onClick={onClaimApproveSubmitClick} type="button">
                                                Approve
                                            </button>
                                        )}
                                        {workflowActionName == "Reject" && (
                                            <button className="btn btn-primary m-1" onClick={onClaimRejectSubmitClick} type="button">
                                                Reject
                                            </button>
                                        )}
                                        <button className="btn btn-primary m-1" onClick={onClaimActionCancelClick} type="button">
                                            Cancel
                                        </button>
                                    </div>
                                )}
                                {workflowActionInprogress && <Spinner />}
                            </div>
                        </form>
                    </div>
                )}
                {isWorkflowActive && (
                    <>
                        {claimWorkflow && (
                            <div className="col-12 card-body">
                                <div className="container-fluid p-2 m-2">
                                    <div className="row p-2">
                                        <div
                                            className={
                                                claimStatusId == 1
                                                    ? "col-6 text-align-right font-weight-bold vertical-align-top"
                                                    : "col-6 text-align-right vertical-align-top"
                                            }
                                        >
                                            Requestor :
                                        </div>
                                        <div className={claimStatusId == 1 ? "col-6 font-weight-bold vertical-align-top" : "col-6 vertical-align-top"}>
                                            {claimWorkflow.requestor.name} {claimStatusId == 1 && <IoIosTimer className="timer-icon-size" />}
                                        </div>
                                    </div>

                                    <div className="row p-2">
                                        <div className="col-6 text-right"></div>
                                        <div className="col-6">
                                            <FaArrowAltCircleDown className="arrow-icon-size" />{" "}
                                        </div>
                                    </div>

                                    {claimTypeValue == 1 && (
                                        <>
                                            <div className="row p-2">
                                                <div
                                                    className={
                                                        claimWorkflow.accountManager.userId == claimWorkflow.currentlyWithUser?.userId
                                                            ? "col-6 text-align-right font-weight-bold vertical-align-top"
                                                            : "col-6 text-align-right vertical-align-top"
                                                    }
                                                >
                                                    Account Manager :
                                                </div>
                                                <div
                                                    className={
                                                        claimWorkflow.accountManager.userId == claimWorkflow.currentlyWithUser?.userId
                                                            ? "col-6 font-weight-bold vertical-align-top"
                                                            : "col-6 vertical-align-top"
                                                    }
                                                >
                                                    {claimWorkflow.accountManager?.name}{" "}
                                                    {claimWorkflow.accountManager.userId == claimWorkflow.currentlyWithUser?.userId && (
                                                        <IoIosTimer className="timer-icon-size" />
                                                    )}
                                                </div>
                                            </div>
                                            <div className="row p-2">
                                                <div className="col-6 text-right"></div>
                                                <div className="col-6">
                                                    <FaArrowAltCircleDown className="arrow-icon-size" />{" "}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <div className="row p-2">
                                        <div
                                            className={
                                                claimWorkflow.level2Investigator.userId == claimWorkflow.currentlyWithUser?.userId
                                                    ? "col-6 text-align-right font-weight-bold vertical-align-top"
                                                    : "col-6 text-align-right vertical-align-top"
                                            }
                                        >
                                            Level 2 Investigator :
                                        </div>
                                        <div
                                            className={
                                                claimWorkflow.level2Investigator.userId == claimWorkflow.currentlyWithUser?.userId
                                                    ? "col-6 font-weight-bold vertical-align-top"
                                                    : "col-6 vertical-align-top"
                                            }
                                        >
                                            {claimWorkflow.level2Investigator?.name}{" "}
                                            {claimWorkflow.level2Investigator.userId == claimWorkflow.currentlyWithUser?.userId && (
                                                <IoIosTimer className="timer-icon-size" />
                                            )}
                                        </div>
                                    </div>
                                    <div className="row p-2">
                                        <div className="col-6 text-right"></div>
                                        <div className="col-6">
                                            <FaArrowAltCircleDown className="arrow-icon-size" />{" "}
                                        </div>
                                    </div>

                                    {claimWorkflow.approver && (
                                        <>
                                            <div className="row p-2">
                                                <div
                                                    className={
                                                        claimWorkflow.approver.userId == claimWorkflow.currentlyWithUser?.userId
                                                            ? "col-6 text-align-right font-weight-bold vertical-align-top"
                                                            : "col-6 text-align-right vertical-align-top"
                                                    }
                                                >
                                                    Approver :
                                                </div>
                                                <div
                                                    className={
                                                        claimWorkflow.approver.userId == claimWorkflow.currentlyWithUser?.userId
                                                            ? "col-6 font-weight-bold vertical-align-top"
                                                            : "col-6 vertical-align-top"
                                                    }
                                                >
                                                    {claimWorkflow.approver?.name}{" "}
                                                    {claimWorkflow.approver.userId == claimWorkflow.currentlyWithUser?.userId && (
                                                        <IoIosTimer className="timer-icon-size" />
                                                    )}
                                                </div>
                                            </div>
                                            <div className="row p-2">
                                                <div className="col-6 text-right"></div>
                                                <div className="col-6">
                                                    <FaArrowAltCircleDown className="arrow-icon-size" />{" "}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <div className="row p-2">
                                        <div className="col-6 text-align-right vertical-align-top">Currently With :</div>
                                        <div className="col-6 vertical-align-top ">
                                            <>
                                                {claimStatusId == 7 || claimStatusId == 8 || claimStatusId == 9 || claimStatusId == 10 ? (
                                                    <>{ClaimStatus[claimStatusId]}</>
                                                ) : (
                                                    <>{claimWorkflow?.currentlyWithUser?.name}</>
                                                )}
                                            </>
                                            <br />
                                            {claimWorkflow.currentlyWithUser?.delegatedUser && (
                                                <>
                                                    {"("} {claimWorkflow.currentlyWithUser?.delegatedUser} {"is delegate for"}{" "}
                                                    {claimWorkflow.currentlyWithUser?.name}
                                                    {" )"}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                )}
                {((isDetailsActive && claimId > 0) || isProductsActive || isWorkflowActive) && (
                    <>
                        <div className="col-12 card-body">
                            <div className="card mt-3">
                                <div className="card-header">
                                    <div className="row m-0">
                                        <div className="col-sm-7 align-content-center">
                                            <span>Attachments</span>
                                        </div>
                                        <div className="col-sm-5 justify-content-end align-content-end text-end">
                                            {" "}
                                            <input
                                                onChange={handleFileChange}
                                                ref={fileInputRef}
                                                type="file"
                                                style={{ display: "none" }}
                                                multiple
                                                name="attachments"
                                            />
                                            <button className="btn btn-primary me-1 btn-sm" onClick={handleAddAttachmentClick} type="button">
                                                Add Attachment
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 card-body">
                                    {showAttachmentsLoader && <Spinner />}
                                    {!showAttachmentsLoader && attachments.length > 0 && getAttachmentsColumns().length > 0 && (
                                        <ReactDataGrid
                                            className="grid-child-container react-grid-cell"
                                            style={{ height: "auto" }}
                                            columns={getAttachmentsColumns()}
                                            rows={attachments}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-12 card-body">
                            <div className="card mt-3">
                                <div className="card-header">
                                    <div className="row m-0">
                                        <div className="col-sm-7 align-content-center">
                                            <span>Comments</span>
                                        </div>
                                        <div className="col-sm-5 justify-content-end align-content-end text-end">
                                            <button className="btn btn-primary me-1 btn-sm" onClick={() => setShowCommentModal(true)} type="button">
                                                Add Comment
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 card-body">
                                    {showCommentsLoader && <Spinner />}
                                    {!showCommentsLoader && comments?.length > 0 && getCommentsColumns().length > 0 && (
                                        <ReactDataGrid
                                            style={{ height: "auto" }}
                                            className="grid-child-container react-grid-cell"
                                            columns={getCommentsColumns()}
                                            rows={comments}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        {showCommentModal && (
                            <div className="modal show d-block" role="dialog" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">
                                                {"New Comment"}
                                            </h5>
                                            {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button> */}
                                        </div>
                                        <div className="modal-body">
                                            <div className="form-row m-1">
                                                <div className="form-group row pb-2">
                                                    <div className="col-md-8">
                                                        <label htmlFor="claimtype" className="col-form-label">
                                                            Comment
                                                        </label>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <textarea
                                                            rows={5}
                                                            className={showNewCommentError ? "form-control is-invalid" : "form-control"}
                                                            onChange={(event) => {
                                                                setNewComment(event.target.value);
                                                                setShowNewCommentError(false);
                                                            }}
                                                            value={newComment}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                                <div className="form-group row pb-2">
                                                    <div className="col-md-8">
                                                        <label htmlFor="claimtype" className="col-form-label">
                                                            Notify
                                                        </label>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <CustomAutoCompleteMultiple
                                                            selectedValue={selectedNotify}
                                                            onChange={(event: any, value: any) => onNotifyUserChange(event, value)}
                                                            id="selectNotifyUsers"
                                                            defaultValue={{ key: "", label: "Select User" }}
                                                            options={getAutoCompleteOptions(userStore.users)}
                                                            multiple={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" onClick={onCommentSaveClick} className="btn btn-primary">
                                                Yes
                                            </button>
                                            <button type="button" className="btn btn-secondary" onClick={() => setShowCommentModal(false)} data-dismiss="modal">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                )}
                {isAuditTrailActive && (
                    <div className="col-12 card-body">
                        {showAuditLoader && <Spinner />}
                        {!showAuditLoader && claimAudit.length > 0 && getAuditTrailColumns().length > 0 && (
                            <ReactDataGrid style={{ height: "auto" }} className="grid-child-container" columns={getAuditTrailColumns()} rows={claimAudit} />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
});
